export class FiltroRelatorioNotasFiscaisCidadao {

    cpf: string;
    tipoPesquisa: number;
    dataInicial : string;
    dataFinal : string;
    municipioId: number;
    tipoExportacao: number;
}



// WEBPACK FOOTER //
// ./src/app/shared/filter/filtro-relatorio-notas-fiscais-cidadao.ts